module.exports = __webpack_public_path__ + "static/media/ico-arrow-open.3acd1b06.svg";